import {useParams} from "react-router-dom";
import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import React, {useEffect} from "react";
import "./style.less"
import useGeneralInfoController from "../../controllers/generalInfo-controller";
import {Spin} from "antd";

const GeneralInfoItemPage = () => {
  const {generalInfoId} = useParams()
  const {isLoading, selectedGeneralInfoItem, getGeneralInfoItemData} = useGeneralInfoController()

  useEffect(() => {
    if (generalInfoId) {
      getGeneralInfoItemData(generalInfoId)
    }
  }, [generalInfoId])


  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">
              {selectedGeneralInfoItem?.title}
            </div>
          </div>
        }
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content">
      <div className="generalItemPage_body">
        {selectedGeneralInfoItem?.link ? (
          <iframe
            className="publicFileView_iframe"
            src={selectedGeneralInfoItem.link}
            title="Public Info Document"
          />
        ) : (
          <Spin spinning={isLoading} size="large"/>
        )}
      </div>
    </div>

  </>
}
export default GeneralInfoItemPage